/**
 * Derives the land NFT type (1-5) from a token ID.
 *
 * The land contract assigns types in repeating 25,000-token cycles:
 *   IDs 1–8000    → Type 1
 *   IDs 8001–15000  → Type 2
 *   IDs 15001–20000 → Type 3
 *   IDs 20001–23000 → Type 4
 *   IDs 23001–25000 → Type 5
 *
 * This mirrors the on-chain pricing logic so the frontend can
 * display types without a backend /nft/bulk lookup.
 */
export function getLandTypeByTokenId(tokenId: number): number | null {
  if (tokenId < 1) return null;

  const positionInCycle = ((tokenId - 1) % 25000) + 1;

  if (positionInCycle <= 8000) return 1;
  if (positionInCycle <= 15000) return 2;
  if (positionInCycle <= 20000) return 3;
  if (positionInCycle <= 23000) return 4;
  if (positionInCycle <= 25000) return 5;

  return null;
}
